/**
 * QUOTE REQUESTS STORE
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
    getQuoteRequests,
    getQuoteRequest,
    printQuoteRequest,
    createQuoteRequests,
    updateQuoteRequests,
    deleteQuoteRequests,
    createEstimateFromQuoteRequest,
    createRfqFromQuoteRequest,
    createPurchaseOrderFromQuoteRequest,
} from "Modules/sales/quote_requests/config/api.quote_requests";

const state = {
    page: {},
    form: {},
    quote_requests: [],
    selectedQuoteRequest: {
        quote_request_id: null,
        company_id: "",
        quote_request_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        quote_request_details: [],
    },
    quote_requests_filter: {
        search: "",
        status_id: "",
        page_size: 2,
        page_num: 1,
    },
    rules_quote_requests: {
        quote_request_id: {
            name: "quote_request_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        company_id: {
            name: "company_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        request_date: {
            name: "request_date",
            rules: "trim|required",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        reference_number: {
            name: "reference_number",
            rules: "trim|max_length[50]",
            max_len: "50",
            min_len: "",
            default_value: "",
        },
        status_id: {
            name: "status_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "16",
        },
        billing_address_id: {
            name: "billing_address_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        bill_location_label: {
            name: "bill_location_label",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        bill_address1: {
            name: "bill_address1",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        bill_address2: {
            name: "bill_address2",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        bill_city: {
            name: "bill_city",
            rules: "trim|max_length[100]",
            max_len: "100",
            min_len: "",
            default_value: "",
        },
        bill_state: {
            name: "bill_state",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        bill_zip_code: {
            name: "bill_zip_code",
            rules: "trim|max_length[5]",
            max_len: "5",
            min_len: "",
            default_value: "",
        },
        bill_zip_code_ext: {
            name: "bill_zip_code_ext",
            rules: "trim|max_length[4]",
            max_len: "4",
            min_len: "",
            default_value: "",
        },
        bill_country_iso_3: {
            name: "bill_country_iso_3",
            rules: "trim|max_length[3]",
            max_len: "3",
            min_len: "",
            default_value: "",
        },
        shipping_address_id: {
            name: "shipping_address_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        ship_location_label: {
            name: "ship_location_label",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        ship_address1: {
            name: "ship_address1",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        ship_address2: {
            name: "ship_address2",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        ship_city: {
            name: "ship_city",
            rules: "trim|max_length[100]",
            max_len: "100",
            min_len: "",
            default_value: "",
        },
        ship_state: {
            name: "ship_state",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        ship_zip_code: {
            name: "ship_zip_code",
            rules: "trim|max_length[5]",
            max_len: "5",
            min_len: "",
            default_value: "",
        },
        ship_zip_code_ext: {
            name: "ship_zip_code_ext",
            rules: "trim|max_length[4]",
            max_len: "4",
            min_len: "",
            default_value: "",
        },
        ship_country_iso_3: {
            name: "ship_country_iso_3",
            rules: "trim|max_length[3]",
            max_len: "3",
            min_len: "",
            default_value: "",
        },
        shipping_carrier_id: {
            name: "shipping_carrier_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        freight_term_id: {
            name: "freight_term_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        currency_id: {
            name: "currency_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        exchange_rate: {
            name: "exchange_rate",
            rules: "trim|max_length[19]|decimal|required",
            max_len: "19",
            min_len: "",
            default_value: "",
        },
        comments: {
            name: "comments",
            rules: "trim",
            max_len: "65535",
            min_len: "",
            default_value: "",
        },
        department_id: {
            name: "department_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        quote_request_details: {
            part_id: {
                name: "part_id",
                rules: "trim|max_length[15]|integer|required",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            sales_unit: {
                name: "sales_unit",
                rules: "trim|max_length[15]|integer|required",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            quantity: {
                name: "quantity",
                rules: "trim|max_length[11]|integer|required",
                max_len: "11",
                min_len: "",
                default_value: "",
            },
            map_id: {
                name: "map_id",
                rules: "trim|max_length[15]|integer|required",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            require_rfq: {
                name: "require_rfq",
                rules: "trim|max_length[1]|integer",
                max_len: "1",
                min_len: "",
                default_value: "",
            },
        },
    },
};

// getters
const getters = {
    quote_requests: (state) => {
        return state.quote_requests;
    },
};

// actions
const actions = {
    async fetchQuoteRequests({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getQuoteRequests({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("setPageQuoteRequests", response.data.page);
                }

                commit("setQuoteRequests", response.data.quote_requests);

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchQuoteRequest({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getQuoteRequest(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("setSelectedQuoteRequest", response.data.quote_request);
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printQuoteRequest({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printQuoteRequest(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveQuoteRequest({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["quote_request_id"] === "undefined" || body["quote_request_id"] == null || body["quote_request_id"] == "") {
                delete body["quote_request_id"];
                response = await createQuoteRequests({ body: body, headers: config.headers });
            } else {
                let quote_request_id = body["quote_request_id"];
                delete body["quote_request_id"];
                response = await updateQuoteRequests({ body: body, headers: config.headers }, quote_request_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async convertQuoteRequestToEstimate({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await createEstimateFromQuoteRequest({ body: body, headers: config.headers }, body.quote_request_id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async convertQuoteRequestToVendorRfqs({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await createRfqFromQuoteRequest({ body: body, headers: config.headers }, body.quote_request_id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async savePurchaseOrderFromQuoteRequest({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await createPurchaseOrderFromQuoteRequest({ headers: config.headers }, payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteQuoteRequest({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteQuoteRequests(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    setPageQuoteRequests(state, page) {
        state.page = page;
    },
    setQuoteRequests(state, quote_requests) {
        state.quote_requests = quote_requests;
    },
    setSelectedQuoteRequest(state, quote_request) {
        state.selectedQuoteRequest = quote_request;
    },
    resetSelectedQuoteRequest(state) {
        for (const key in state.selectedQuoteRequest) {
            if (key in state.rules_quote_requests) {
                state.selectedQuoteRequest[key] =
                    state.rules_quote_requests[key].default_value == "null" ? null : state.rules_quote_requests[key].default_value;
            }
        }
    },
    resetQuoteRequests(state) {
        state.page = {};
        state.form = {};
        state.quote_requests = [];
        state.selectedQuoteRequest = {
            quote_request_id: null,
            company_id: "",
            quote_request_date: "",
            reference_number: "",
            status_id: "",
            billing_address_id: "",
            shipping_address_id: "",
            comments: "",
            quote_request_details: [],
        };
        state.quote_requests_filter = {
            search: "",
            status_id: "",
            page_size: 2,
            page_num: 1,
        };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
